import "./header.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "../../context/Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCircleXmark,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

export default function Header() {
  const { user, dispatch } = useContext(Context);
  const [searchOpen, setSearchOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
    navigate("/");
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMenuOpen]);

  return (
    <div className="header-smaller-screen">
      <div className="logoHome">
        <Link to="/">
          <img
            src={
              process.env.REACT_APP_AWS_S3_IMAGE_FRONTEND_URL +
              "/Logo_FLOW_New_Cropped_800x800.png"
            }
            alt="Logo"
          />
        </Link>
      </div>
      <div className="header-right-Home">
        {user ? (
          <>
            {user.isAuthor ? (
              <>
                <div className="sign-in" onClick={handleLogout}>
                  <a
                    href="#"
                    className="link-style-header"
                    onClick={handleLogout}
                  >
                    LOGOUT
                  </a>
                </div>
              </>
            ) : (
              <div className="sign-in" onClick={handleLogout}>
                <a href="#" className="link-style-header">
                  LOGOUT
                </a>
              </div>
            )}
          </>
        ) : (
          <div className="sign-in">
            <Link
              to="/login"
              className="link-style-header"
              onClick={handleLinkClick}
            >
              SIGN IN
            </Link>
          </div>
        )}
        <Link to="/subscribe">
          <button
            className="subscribe-btn-Home buttonHome"
            onClick={handleLinkClick}
          >
            SUBSCRIBE
          </button>
        </Link>
        <div className="search-icon" onClick={() => setSearchOpen(true)}>
          <div className="mr-4 inline-block cursor-pointer p-2 text-xl text-dark transition hover:text-primary md:mr-0">
            <FontAwesomeIcon icon={faSearch} size="2x" />
          </div>
        </div>
        <div className="hamburger-icon">
          <input
            id="menu__toggle"
            type="checkbox"
            checked={isMenuOpen}
            onChange={() => setIsMenuOpen(!isMenuOpen)}
          />
          <label className="menu__btn" htmlFor="menu__toggle">
            <FontAwesomeIcon
              icon={faBars}
              size="2x"
              style={{ width: "50px", height: "50px", cursor: "pointer" }}
            />
          </label>
          <div className="menu__overlay" onClick={handleLinkClick}></div>
          <ul className="menu__box" ref={menuRef}>
            <div style={{ marginTop: "115px" }}>
              <li className="menu__item">
                <Link to="/" onClick={handleLinkClick}>
                  Home
                </Link>
              </li>
              {user?.role > 2 && (
                <>
                  <li className="menu__item">
                    <Link to="/write" onClick={closeMenu}>
                      The Writer's Room
                    </Link>
                  </li>
                  <li className="menu__item">
                    <Link to="/edit" onClick={closeMenu}>
                      Editorial Dashboard
                    </Link>
                  </li>
                </>
              )}
              <li className="menu__item">
                <Link to="/articles" onClick={handleLinkClick}>
                  Read Our Articles
                </Link>
              </li>
              <li className="menu__item">
                <Link to="/authors" onClick={handleLinkClick}>
                  Meet Our Writers
                </Link>
              </li>
              <li className="menu__item">
                <Link to="/categories" onClick={handleLinkClick}>
                  Choose Your Genre
                </Link>
              </li>
              <li className="menu__item">
                <Link to="/profile" onClick={handleLinkClick}>
                  Manage Your Account
                </Link>
              </li>
              {user?.role > 4 && (
                <li className="menu__item">
                  <Link to="/admin" onClick={closeMenu}>
                    Admin Dashboard
                  </Link>
                </li>
              )}
              <li className="menu__item">
                {user ? (
                  <a href="#" onClick={handleLogout} className="link-style">Logout</a>
                ) : (
                  <Link to="/login" className="link-style" onClick={handleLinkClick}>Sign In</Link>
                )}
              </li>
            </div>
          </ul>
          <label htmlFor="menu__toggle" className="close__btn">
            <FontAwesomeIcon icon={faCircleXmark} size="2x" />
          </label>
        </div>
      </div>
      {searchOpen && <SearchBar onClose={() => setSearchOpen(false)} />}
      <div className="main-content">
        <div className="content-blur-target">{/* Main content goes here */}</div>
      </div>
    </div>
  );
}

function SearchBar({ onClose }) {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const searchBarRef = useRef(null);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
      onClose();
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchBarRef.current && !searchBarRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleEscapePress = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapePress);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapePress);
    };
  }, []);

  const handleClearInput = () => {
    setSearchQuery("");
  };

  return (
    <div className="search-overlay">
      <div className="search-bar-modal" ref={searchBarRef}>
        <button className="search-bar-close" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <form className="search-bar-form" onSubmit={handleSearchSubmit}>
          <input
            type="text"
            placeholder="Search our library..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-bar-input"
            autoFocus
          />
          <button type="submit" className="search-bar-icon">
            <FontAwesomeIcon icon={faSearch} />
          </button>
        </form>
      </div>
    </div>
  );
}
